import { OptionProps } from '@mui/base';
import { Translation } from 'hooks/useTranslation/useTranslation';

export const createReasonSelectOptions = (translation: Translation): Array<OptionProps<null | string>> => [
  {
    value: 'NO_TOKEN',
    label: translation.no_token
  },
  {
    value: 'DOM_UNKNOWN',
    label: translation.unknown
  }
];
